<template>
	<div>
		<avue-form v-model="formPlan" :option="optionPlan" @submit="submitPlan">
			<template slot="menuForm">
				<el-button v-if="isSubmitted && (!readOnly || forceModify)" icon="el-icon-edit" @click="modifyPlan">
					修改
				</el-button>
			</template>

			<template v-if="insureType == 13" slot="insuredItem1Label">
				<div>意外医药补偿（每次意外事故限额）</div>
				<div>（中国大陆境内医药费用仅限当地社保规定个人自负部分）</div>
				<div>（含救护车费用年度累计限额RMB1,000）</div>
			</template>
			<template v-if="insureType == 13" slot="insuredItem2Label">
				<div>意外每日住院津贴</div>
				<div>（每一保险年度总赔偿日数以180天为限）</div>
			</template>
		</avue-form>
		<el-dialog :visible.sync="confirmDialogVisible" center title="提示" width="40%">
			<el-row>
				当前选择的保额为
				<span style="font-weight: bold; color: red">{{ formPlan.coverage }}万</span>
				，为了保障您的权益，请勾选确认：
			</el-row>
			<el-row>
				<el-checkbox v-model="planWarning1Checked">我已确认{{ formPlan.coverage }}万保额是符合要求的</el-checkbox>
			</el-row>
			<el-row>
				<el-checkbox v-model="planWarning2Checked">
					我已了解“按照相关法规，{{ formPlan.coverage }}万保额已无法满足工伤事故赔偿最低标准”
				</el-checkbox>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="confirmDialogVisible = false">更改保额</el-button>
				<el-button
					:disabled="!planWarning1Checked || !planWarning2Checked"
					size="medium"
					type="primary"
					@click="confirmPlan">
					确认
				</el-button>
			</span>
		</el-dialog>

		<el-dialog :visible.sync="isShowNoFeeRate" center title="提示" top="30vh" width="40%">
			<div class="u-flex u-row-center u-m-b-10 u-m-t-10">
				<span class="red-bold">本保单不承保货车司机和随车人员参与装卸货物有关工作发生的工伤和意外伤害的赔偿责任。</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="onNoFeeRateAgree">谢谢，投/被保险人不同意此告知。</el-button>
				<el-button type="primary" @click="isShowNoFeeRate = false">
					已知悉，我已告知投/被保险人，并取得投/被保险人的同意。
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import {
	mapPlan_10,
	mapPlan_11,
	mapPlan_12,
	mapPlan_13,
	mapPlan_14,
	mapPlan_15,
	mapPlan_16,
	mapPlan_17,
	mapPlan_18,
	mapPlan_21,
	mapPlan_22,
	mapPlan_23,
	mapPlan_29,
	mapPlan_3,
	mapPlan_6,
	mapPlan_7,
	mapPlan_8,
	mapPlan_9_High,
	mapPlan_9_Low,
	optionPlan_11,
	optionPlan_12,
	optionPlan_13,
	optionPlan_14,
	optionPlan_15,
	optionPlan_16,
	optionPlan_17,
	optionPlan_18,
	optionPlan_21,
	optionPlan_22,
	optionPlan_23,
	optionPlan_29,
	optionPlan_3,
	optionPlan_6,
	optionPlan_7,
	optionPlan_8,
	optionPlan_9,
} from '@/const/crud/insurance/plan'
import {isAnZe15, isFgkDoor, isFgkGuangfu, isJiaDianLong, isMeiYaC, isXsmYunShu} from '@/util/productUtil'

export default {
	name: 'PlanForm',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
		productCode: {
			type: String,
			required: true,
		},
		insureType: {
			type: Number | String,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		coverageNotice: {
			type: Number,
			default: 0,
		},
		planCoverage: {
			type: Array,
		},
	},
	data() {
		return {
			optionPlan: {},
			mapPlan: {},
			formPlan: {
				coverage: '',
				feeRate: '',
				addMaim: '',
				thirdDuty: '',
				costDuty: '',
				allDuty: '',
				//泰康雇主
				delayFee: '',
				medicalFee: '',
				insureSuddenDeath: '',
				professionLevel: '',
				insuredItem1: '',
				insuredItem2: '',
				insuredItem3: '',
			},

			planItems: new Map([
				[3, [mapPlan_3]],
				[6, [mapPlan_6]],
				[7, [mapPlan_7]],
				[8, [mapPlan_8]],
				[9, [mapPlan_9_Low, mapPlan_9_High]],
				[10, [mapPlan_10]],
				[11, [mapPlan_11]],
				[12, [mapPlan_12]],
				[13, [mapPlan_13]],
				[15, [mapPlan_15]],
				[14, [mapPlan_14]],
				[16, [mapPlan_16]],
				[17, [mapPlan_17]],
				[18, [mapPlan_18]],
				[19, [mapPlan_16]],
				[21, [mapPlan_21]],
				[22, [mapPlan_22]],
				[23, [mapPlan_23]],
				[29, [mapPlan_29]],
			]),

			planOptions: new Map([
				[3, optionPlan_3],
				[6, optionPlan_6],
				[7, optionPlan_7],
				[8, optionPlan_8],
				[9, optionPlan_9],
				[10, optionPlan_6],
				[11, optionPlan_11],
				[12, optionPlan_12],
				[13, optionPlan_13],
				[15, optionPlan_15],
				[14, optionPlan_14],
				[16, optionPlan_16],
				[17, optionPlan_17],
				[18, optionPlan_18],
				[19, optionPlan_16],
				[21, optionPlan_21],
				[22, optionPlan_22],
				[23, optionPlan_23],
				[29, optionPlan_29],
			]),

			dicHighLevel: [],
			dicLowLevel: [],

			confirmDialogVisible: false,
			planWarning1Checked: false,
			planWarning2Checked: false,

			isSubmitted: false,
			//  国寿财批增，如原始保单选择2档费率，需让用户在1、3档中重新选择
			forceModify: false,
			thirdType: '0',
			isShowNoFeeRate: false,
		}
	},
	watch: {
		productCode: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					this.resetForm()
				}
			},
		},
		insureType: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					this.resetForm()
				}
			},
		},
		'formPlan.coverage': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					Object.assign(this.formPlan, this.mapPlan.get(newVal))
					if (this.insureType != 11) {
						this.$emit('planChange')
					} else {
						this.$emit('categoryFiltered', newVal > 60)
					}
				}
			},
		},
		'formPlan.addMaim': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					this.$emit('planChange')
					//如果是门窗或者光伏，则需要发送盖章文件
					if (isFgkDoor(this.productId) || isFgkGuangfu(this.productId)) {
						this.$Bus.$emit('onBusFileConfirm', {interType: 'plan', planType: newVal})
					}
				}
			},
		},
		'formPlan.allDuty': {
			handler(newVal) {
				if (!this.validatenull(newVal) && (isAnZe15(this.insureType) || isXsmYunShu(this.insureType))) {
					this.$emit('planChange')
				}
			},
		},
		'formPlan.delayFee': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					this.$emit('planChange')
				}
			},
		},
		'formPlan.medicalFee': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					this.$emit('planChange')
				}
			},
		},
		'formPlan.thirdDuty': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					if (this.onJiandianThird()) {
						//处理显隐藏
						this.findObject(this.optionPlan.column, 'insuredItem4').display = newVal === '1'
						this.$emit('planChange')
					}
				}
			},
		},
		'formPlan.insureSuddenDeath': {
			handler(newVal, oldVal) {
				if (this.insureType == 11) {
					if (!this.validatenull(newVal) && !this.validatenull(oldVal)) {
						let pid = parseInt(this.productId)
						this.$emit('insureSuddenDeath', newVal, newVal == true ? pid + 1 : pid - 1)
					}
				}
			},
		},
		'formPlan.costDuty': {
			handler(newVal, oldVal) {
				//美亚 是否扩展自费药方案
				if (!this.validatenull(newVal)) {
					this.$emit('planChange')
				}
			},
		},
		'formPlan.feeRate': {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
					if (this.insureType == 8) {
						if (!this.validatenull(newVal)) {
							if (newVal != 1.1) {
								this.$emit('planChange')
							} else {
								this.$nextTick(() => {
									this.formPlan.feeRate = ''
									this.optionPlan.submitBtn = true
									this.optionPlan.column.forEach((item, index) => {
										if (item.prop == 'feeRate') {
											item.disabled = false
										}
									})
									this.isSubmitted = false
									this.forceModify = true
								})
							}
						}
					} else {
						this.$emit('planChange')
						if (isXsmYunShu(this.insureType)) {
							if (newVal === 0) {
								//弹窗提示
								this.isShowNoFeeRate = true
							}
						}
					}
				}
			},
		},
		'formPlan.professionLevel': {
			handler(newVal) {
				if (!this.validatenull(newVal) && this.insureType == 9) {
					this.optionPlan.column.forEach((item, index) => {
						if (item.prop == 'coverage') {
							item.dicData = newVal == 2 ? this.dicLowLevel : this.dicHighLevel
							if (this.formPlan.coverage > item.dicData[item.dicData.length - 1].value) {
								this.formPlan.coverage = ''
							}
							this.$emit('levelChange', newVal)
						}
					})
				}
			},
		},
		planCoverage: {
			handler(newVal) {
				if (!this.validatenull(newVal)) {
				}
			},
		},
	},
	mounted() {
		this.init()
	},
	activated() {
		//监听家电发送的数据
		this.$Bus.$on('onThird', this.onThirdChange)
	},
	deactivated() {
		this.$Bus.$off('onThird', this.onThirdChange)
	},
	methods: {
		init() {
			let coverage = 10
			while (coverage <= 100) {
				let item = {
					label: coverage + '万',
					value: coverage,
				}

				if (coverage <= 60) {
					this.dicHighLevel.push(item)
				}
				this.dicLowLevel.push(item)

				coverage += 10
			}

			this.resetForm()
		},
		resetForm() {
			if (!this.validatenull(this.insureType)) {
				if (this.validatenull(this.optionPlan)) {
					this.optionPlan = this.deepClone(this.planOptions.get(this.insureType))
					if (this.readOnly) {
						this.optionPlan.submitBtn = false
						this.optionPlan.column.forEach((item, index) => {
							item.disabled = true
						})
						this.isSubmitted = true
					}
					if (this.insureType == 13) {
						let tempCostDuty = this.findObject(this.optionPlan.column, 'costDuty')
						//如果是美亚C款，则需要显示扩展自费方案
						tempCostDuty.display = isMeiYaC(this.insureType, this.productId)
					}
					if (this.insureType == 6 && (isFgkGuangfu(this.productId) || isFgkDoor(this.productId))) {
						//光伏，则展示
						let tempAddMaim = this.findObject(this.optionPlan.column, 'addMaim')
						tempAddMaim.display = true
					}
					//门窗需要去掉120万
					if (isFgkDoor(this.productId)) {
						this.findObject(this.optionPlan.column, 'coverage').dicData.pop()
					}
				}

				if (this.insureType == 9) {
					// if (!this.validatenull(this.productCode)) {
					//   this.mapPlan = this.planItems.get(this.insureType)[this.productCode.indexOf('HIGH') != -1 ? 1 : 0]
					// }
					// //  Added by Li Yong on 2021/12/23
					// //  亚太批增时隐藏工种大类属性，通过接口限制可投保工种
					// if (this.readOnly) {
					//   this.optionPlan.column.forEach((item) => {
					//     if (item.prop == 'professionLevel') {
					//       item.display = false
					//     }
					//   })
					// }
				} else {
					this.mapPlan = this.planItems.get(this.insureType)[0]
				}

				if (this.insureType == 11 && !this.validatenull(this.productCode)) {
					let arrCode = this.productCode.split('-') || []
					let suddenDeathFlag = arrCode[arrCode.length - 2] || ''
					this.formPlan.insureSuddenDeath = suddenDeathFlag == 'CS' ? 1 : 0
				}

				//阳光驾意险，去除是否扩展伤残
				if (this.insureType == 14) {
					this.formPlan.addMaim = '0'
				}
			}
		},
		submitPlan(form, done) {
			if (form.coverage >= this.coverageNotice) {
				this.$message({
					message: '确认 成功',
					type: 'success',
				})

				this.confirmPlan()
			} else {
				this.confirmDialogVisible = true
			}
			done()
		},
		confirmPlan() {
			this.optionPlan.submitBtn = false
			this.optionPlan.column.forEach((item, index) => {
				if (
					item.type === 'select' &&
					(item.prop !== 'allDuty' || isAnZe15(this.insureType) || isXsmYunShu(this.insureType))
				) {
					item.disabled = true
				}
			})
			this.planWarning1Checked = false
			this.planWarning2Checked = false
			this.confirmDialogVisible = false
			this.isSubmitted = true
			this.$emit('onSubmitted', this.getSubmitData())
		},
		modifyPlan() {
			this.optionPlan.submitBtn = true
			this.optionPlan.column.forEach((item, index) => {
				if (!this.forceModify) {
					if (
						item.type === 'select' &&
						(item.prop !== 'allDuty' || isAnZe15(this.insureType) || isXsmYunShu(this.insureType))
					) {
						item.disabled = false
					}
				} else {
					if (item.prop === 'feeRate') {
						item.disabled = false
					}
				}
			})
			this.isSubmitted = false
			this.$emit('onUnsubmitted')
		},
		getSubmitData() {
			// let {coverage, feeRate, insureSuddenDeath, professionLevel, addMaim, costDuty = '', thirdDuty, allDuty, delayFee, medicalFee} = this.formPlan
			// return {
			//   coverage,
			//   feeRate,
			//   insureSuddenDeath,
			//   professionLevel,
			//   addMaim,
			//   costDuty,
			//   thirdDuty,
			//   allDuty,
			//   delayFee,
			//   medicalFee
			// }
			return this.formPlan
		},
		getData() {
			return this.formPlan
		},
		setData(data = {}) {
			Object.assign(this.formPlan, data)
		},
		hideCostDuty() {
			let tempCostDuty = this.findObject(this.optionPlan.column, 'costDuty')
			tempCostDuty.display = false
		},
		////0--没有购买过,1--买过不含三者,2--买过含三者
		onThirdChange(type) {
			this.thirdType = type
		},
		// 家电三者提示
		onJiandianThird() {
			let isContinue = true
			if (isJiaDianLong(this.insureType)) {
				let hint = ''
				//家电 //0--没有购买过,1--买过不含三者,2--买过含三者
				let {thirdDuty = ''} = this.formPlan
				if (this.thirdType === '0') {
					hint =
						thirdDuty === '1'
							? '您已选择投保附加三者责任险，则后期购买该方案时都必须选择购买三者责任险，如已清楚了解，请点击确认。'
							: '您未选择投保附加三者责任险，则后期购买该方案时均无法再购买三者责任险，如已清楚了解，请点击确认。'
				} else if (this.thirdType === '1' && thirdDuty === '1') {
					hint =
						'贵单位已有在保保单未选购三者责任险，新投保也不支持购买三者责任险。原因：同一单位，在保保单若未选购三者责任险，后续投保将默认无法选购。'
					isContinue = false
				} else if (this.thirdType === '2' && thirdDuty === '0') {
					hint =
						'贵单位已有在保保单选购三者责任险，新投保也必须购买三者责任险。原因：同一单位，在保保单若选购三者责任险，后续投保将默认选购。'
					isContinue = false
				}
				if (hint !== '') {
					this.$alert(hint, '提示').then(() => {})
				}
				if (!isContinue) {
					this.formPlan.thirdDuty = ''
					this.isSubmitted = false
				}
			}
			return isContinue
		},
		onNoFeeRateAgree() {
			this.isShowNoFeeRate = false
			this.formPlan.feeRate = 1
		},
	},
}
</script>
